import { TranslationAction } from './types';

/*
 * This diff is merged into the translations and the translation-interface for local development.
 *
 * If you want them to become "productive":
 * - You can update them manually in the POEditor-Interface or via API request (`pnpm pushTranslations`)
 * - You set it back to an empty array if finished successfully
 *
 */
export const diff: TranslationAction[] = [];
